import { cx } from '@emotion/css';
import { SectionLink } from './section-link';
import { GlobalLink, Section } from '../../domain/static-content/static-content.static-generation.model';
import slugify from 'slugify';
import { DSHeading } from '@stihl-design-system/components';
import { cn } from '@phoenix/design-system/frontend/util/classNameUtils';

interface FooterSectionProps {
  section: Section;
  minimal: boolean;
  className?: string;
}

export const FooterSection = ({ section, minimal, className }: FooterSectionProps) => {
  // Calculate number of columns needed (1 column for 3 or fewer links, 2 columns for 4-6 links, etc.)
  const numLinks = section?.links?.length ?? 0;
  const numColumns = Math.ceil(numLinks / 3);
  const linksPerColumn = Math.ceil(numLinks / numColumns);

  // Split links into columns
  const columns =
    section?.links?.reduce((acc, link, index) => {
      const columnIndex = Math.floor(index / linksPerColumn);
      if (!acc[columnIndex]) {
        acc[columnIndex] = [];
      }
      acc[columnIndex].push(link);
      return acc;
    }, [] as GlobalLink[][]) || [];

  return (
    <nav aria-labelledby={section.title ? `${slugify(section.title)}-heading` : undefined} className={cx('col-span-12', className)}>
      {!minimal && (
        <DSHeading tag="h2" className="stihl-text-h5-desktop mb-6" id={section.title ? `${slugify(section.title)}-heading` : undefined}>
          {section.title}
        </DSHeading>
      )}
      <div className={cn(columns.length > 1 && 'grid grid-cols-12 gap-4')}>
        {columns.map((columnLinks, columnIndex) => (
          <ul
            key={`footer-column-${columnLinks[0]?.id ?? columnIndex}`}
            className={cx(
              'col-span-12',
              columns.length > 1 && columnIndex === 0 ? 'md:col-span-5 lg:col-span-4' : 'md:col-span-6',
              minimal && 'flex flex-col justify-center not-last:space-y-4 uppercase',
              !minimal && 'not-last:mt-6 space-y-4'
            )}
          >
            {columnLinks.map((link: GlobalLink) => (
              <SectionLink key={link.id} {...link} />
            ))}
          </ul>
        ))}
      </div>
    </nav>
  );
};
